/**
 * Uncaged Ergonomics — homepage interaction tracking.
 * Pushes to dataLayer and gtag when available (Shopify / PageFly / GTM).
 * Does not replace Shopify Online Store analytics from content_for_header.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function ucTrack(name, params) {
    var payload = Object.assign({ event: name }, params || {});
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  }

  window.ucTrack = ucTrack;

  function readTrackEl(el) {
    return {
      uc_element: el.getAttribute('data-uc-track') || 'unknown',
      uc_label: el.getAttribute('data-uc-track-label') || (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120),
      uc_link_url: el.getAttribute('data-uc-track-dest') || el.getAttribute('href') || ''
    };
  }

  var navTrackIds = {
    shop_all: true,
    mega_collection: true,
    mega_sale: true,
    mega_bulk_pricing: true,
    mega_view_all: true
  };

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest('[data-uc-track]');
      if (!el || el.tagName === 'FORM') return;
      var payload = readTrackEl(el);
      ucTrack('uc_homepage_click', payload);
      if (navTrackIds[payload.uc_element]) {
        ucTrack('uc_nav_click', payload);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var trackId = form.getAttribute('data-uc-track');
      if (!trackId && form.id !== 'uc-footer-newsletter') return;
      ucTrack('uc_homepage_click', {
        uc_element: trackId || 'newsletter_signup',
        uc_label: form.getAttribute('data-uc-track-label') || 'Newsletter signup',
        uc_link_url: window.location.pathname
      });
    },
    true
  );
})();
